import React from 'react';

// Msg #786 — Login-time unread PM modal.
// Shows once per session (or when re-opened manually) with a per-sender
// breakdown of unread whispers.  Actions: Open Messenger  |  Dismiss.
export const UnreadPmModal = ({ open, total, senders, onOpenMessenger, onDismiss }) => {
  if (!open || !total) return null;
  const list = Array.isArray(senders) ? senders.slice(0, 8) : [];
  return (
    <div
      data-testid="unread-pm-modal-backdrop"
      style={{
        position: 'fixed', inset: 0,
        backgroundColor: 'rgba(20,40,20,0.55)',
        zIndex: 1300, display: 'flex',
        alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onDismiss}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        data-testid="unread-pm-modal"
        style={{
          width: 440, maxWidth: '92vw',
          background: '#d6e8c5',
          border: '2px solid #2d6b1e',
          boxShadow: '0 10px 30px rgba(20,40,20,0.5)',
          padding: '18px 22px',
          fontFamily: 'Arial, Helvetica, sans-serif',
          color: '#1c3a1c',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
          <div style={{ fontSize: 26 }}>📮</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold', fontSize: 15 }} data-testid="unread-pm-title">
              You have {total} unread message{total === 1 ? '' : 's'}
            </div>
            <div style={{ fontSize: 11, color: '#3a5a3a' }}>
              waiting in your Messenger since your last visit.
            </div>
          </div>
        </div>
        <div
          data-testid="unread-pm-sender-list"
          style={{
            background: '#e9f3da',
            border: '1px solid #5b8c47',
            padding: '6px 10px',
            marginBottom: 12,
            maxHeight: 180,
            overflowY: 'auto',
          }}
        >
          {list.length === 0 && (
            <div style={{ fontStyle: 'italic', color: '#3a5a3a', fontSize: 12 }}>
              (details unavailable — open Messenger to view)
            </div>
          )}
          {list.map((s) => (
            <div
              key={s.from_name || s.from_user_id}
              data-testid={`unread-pm-sender-${s.from_name}`}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                fontSize: 12, padding: '3px 0',
                borderBottom: '1px dotted #7a9c5c',
              }}
            >
              <span style={{ color: s.from_color || '#5a3a8a', fontWeight: 'bold' }}>
                {s.from_name}
              </span>
              <span
                style={{
                  background: '#7a1f1f', color: '#fff3d0',
                  padding: '1px 5px', borderRadius: 6,
                  fontSize: 10, fontWeight: 'bold',
                }}
              >
                {s.count}
              </span>
              <span style={{ color: '#3a5a3a', fontStyle: 'italic', flex: 1 }}>
                {(s.latest_text || '').slice(0, 40)}
                {(s.latest_text || '').length > 40 ? '…' : ''}
              </span>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            data-testid="unread-pm-dismiss"
            onClick={onDismiss}
            style={{
              background: '#e9f3da',
              border: '1px solid #5b8c47',
              padding: '4px 14px',
              fontSize: 12,
              cursor: 'pointer',
              color: '#1c3a1c',
            }}
          >
            Dismiss
          </button>
          <button
            data-testid="unread-pm-open"
            onClick={onOpenMessenger}
            style={{
              background: '#1c3a1c',
              color: '#ecfcd9',
              border: '1px solid #2d6b1e',
              padding: '4px 14px',
              fontSize: 12,
              fontWeight: 'bold',
              cursor: 'pointer',
              letterSpacing: 1,
            }}
          >
            OPEN MESSENGER
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnreadPmModal;
